export default "__VITE_ASSET__Dc3QStt4__"